import Header from "@/components/Header";
import Hero from "@/components/Hero";
import ShopByCategory from "@/components/ShopByCategory";
import Collections from "@/components/Collections";
import Gallery from "@/components/Gallery";
import WhyChoose from "@/components/WhyChoose";
import HowItWorks from "@/components/HowItWorks";
import FAQ from "@/components/FAQ";
import TradeFair from "@/components/TradeFair";
import FinalCTA from "@/components/FinalCTA";
import Footer from "@/components/Footer";
import FloatingWhatsApp from "@/components/FloatingWhatsApp";
import FloatingCart from "@/components/FloatingCart";
import CartDrawer from "@/components/CartDrawer";
import StripeReturn from "@/components/StripeReturn";
import SEO from "@/components/SEO";
import AnnouncementBar from "@/components/AnnouncementBar";
import { useEffect } from "react";
import { trackPageView } from "@/lib/analytics";

export default function Home() {
  useEffect(() => { trackPageView("/"); }, []);
  return (
    <div className="bg-[#0A0A0A] text-white" data-testid="home-page">
      <SEO />
      <AnnouncementBar />
      <Header />
      <main>
        <Hero />
        <ShopByCategory />
        <Collections />
        <WhyChoose />
        <HowItWorks />
        <Gallery />
        <FAQ />
        <TradeFair />
        <FinalCTA />
      </main>
      <Footer />
      <FloatingWhatsApp />
      <FloatingCart />
      <CartDrawer />
      <StripeReturn />
    </div>
  );
}
